import { Placeholder } from "react-bootstrap"

export const layoutTypeInfoData = {
    "direction": { type: "Select", defaultValue: "row", choices: [{ value: "column", title: "Column" }, { value: "row", title: "Row" }], labelName: "Direction" },
    "isSymetricalForOpponents": { type: "Bool", defaultValue: false, labelName: "Is symetrical for opponents" },
    "content": { type: "Layout" },
    "style": { type: "String", defaultValue: "" }
}

export const gameFileInfoData = {
    defaultValue: {
        "name": "",
        "menuBackgroundImage": "",
        "defaultRessources": {
            "backgrounds": [],
            "decksUrl": ""
        },
        "customHelp": "",
        "cardRotation": 45,
        "cards": {
            "dataUrl": "",
            "cardBack": ""
        },
        "deckBuilding": {
            "mainFilters": [],
            "formats": []
        },
        "gameplay": {
            "Classic": {
                "mulligan": {
                    "info": "",
                    "startingHandSize": 7,
                    "drawNewHand": true,
                    "putSelectionAtBottom": false,
                    "drawNewSelectedCards": false,
                },
                "newTurn": {
                    "drawOnStart": false,
                    "sharedTurn": false,
                    "firstPlayerTokenName": "",
                    "drawPerTurn": 1
                },
                "defaultNotes": "",
                "tokens": [],
                "countersStartingValues": [
                    0
                ],
                "hideFacedDownCards": false,
                "sections": {
                    "customSections": [
                        "Mana"
                    ],
                    "layout": {
                        "direction": "row",
                        "isSymetricalForOpponents": false,
                        "content": []
                    },
                    "categoriesAlreadyOnBoard": [],
                    "autoPlayFromHand": {},
                    "autoPlayFromStack": {},
                    "sectionsDict": {
                        "Mana": {
                            "title": "Mana",
                            "isHidden": "yes",
                            "height": "SMALL",
                            "alignment": "START",
                            "opponentAlignment": false,
                            "noAutoPayTo": "true",
                            "isHorizontalAllowed": false,
                            "displayedTitle": "Ressources",
                            "enterTapped": false,
                            "enterSpun": false,
                            "isGroupForbidden": false,
                            "keepTappedNewTurn": false,
                            "showHiddenCardInHistory": false
                        }
                    }
                }
            }
        }
    },
    "name": { type: "String", defaultValue: "", className: "box-secondary", labelName: "Game name", help: "Decks saved by users will be identified by this. It needs to be unique and never change it after sharing your game" },
    "menuBackgroundImage": { type: "String", defaultValue: "", className: "box-secondary", labelName: "Game image URL", help: "The image used as a background in the menu/deckbuilder." },
    "deckBuilding": {
        className: "box-primary",
        labelTitle: "Deck Building",
        "mainFilters": {
            className: "box-secondary",
            labelSubtitle: "Main filters",
            help: "Filters displayed below the search bar in the deckbuilder. Recommended 3, max 4. Make sure the name match the key used in your card list file. Default keys you can use are: type, cost or name",
            arrayContent: {
                arrayKey: { type: "String", defaultValue: "" }
            },
            defaultValue: ""
        },
        "formats": {
            className: "box-secondary",
            labelSubtitle: "Game formats",
            arrayContent: {
                "title": { type: "String", defaultValue: "", labelName: "Format title" },
                "gameplay": { type: "String", defaultValue: "", labelName: "Gameplay identifier", help: "The title of the gameplay used for this format. Define them below in the Gameplay Data section." },
                customCategories: {
                    labelName: "Custom categories",
                    help: "Custom categories in the deckbuilder.",
                    arrayContent: {
                        arrayKey: { type: "String", defaultValue: "" }
                    },
                    defaultValue: ""
                }
            },
            defaultValue: {
                title: "",
                gameplay: "",
                customCategories: []
            }
        }
    },
    "gameplay": {
        defaultValue: {
            "mulligan": {
                "info": "",
                "startingHandSize": 7,
                "drawNewHand": true,
                "putSelectionAtBottom": false,
                "drawNewSelectedCards": false,
            },
            "newTurn": {
                "drawOnStart": false,
                "sharedTurn": false,
                "firstPlayerTokenName": "",
                "drawPerTurn": 1
            },
            "defaultNotes": "",
            "tokens": [],
            "countersStartingValues": [
                0
            ],
            "hideFacedDownCards": false,
            "sections": {
                "customSections": [
                    "Mana"
                ],
                "layout": {
                    "direction": "row",
                    "isSymetricalForOpponents": false,
                    "content": []
                },
                "categoriesAlreadyOnBoard": [],
                "autoPlayFromHand": {},
                "autoPlayFromStack": {},
                "sectionsDict": {
                    "Mana": {
                        "title": "Mana",
                        "isHidden": "yes",
                        "height": "SMALL",
                        "alignment": "START",
                        "opponentAlignment": false,
                        "noAutoPayTo": true,
                        "isHorizontalAllowed": false,
                        "displayedTitle": "Ressources",
                        "noQuickActions": false,
                        "enterTapped": false,
                        "enterSpun": false,
                        "isGroupForbidden": false,
                        "keepTappedNewTurn": false,
                        "showHiddenCardInHistory": false
                    }
                }
            }
        },
        labelTitle: "Gameplay data",
        isDictionary: true,
        hasMultipleKeys: true,
        dictionaryKey: {
            className: "sub-section",
            "mulligan": {
                "info": { type: "String", defaultValue: "", labelName: "Mulligan description", help: "Text displayed to players in the mulligan section" },
                "startingHandSize": { type: "Number", defaultValue: 7, labelName: "Starting hand size" },
                "drawNewHand": { type: "Bool", defaultValue: false, labelName: "Allowed to draw a new hand", help: "Allow to shuffle the hand back into the deck and draw a new hand" },
                "putSelectionAtBottom": { type: "Bool", labelName: "Allowed to put selection at bottom of deck", help: "Allows to select cards in hand and put them at bottom of deck. Close the mulligan menu" },
                "drawNewSelectedCards": { type: "Bool", labelName: "Allowed to put selection back and draw again", help: "Allows to put back the selected cards into the deck and draw the same number of new cards" },
                className: "box-secondary",
                labelSubtitle: "Mulligan options"
            },
            "newTurn": {
                "drawOnStart": { type: "Bool", defaultValue: false, labelName: "First player draw at game start" },
                "sharedTurn": { type: "Bool", defaultValue: false, labelName: "Shared turn" },
                "firstPlayerTokenName": { type: "String", defaultValue: "", labelName: "First player token name", help: "Token go represent the first player. Use the name of the token defined in the Tokens section below" },
                "drawPerTurn": { type: "Number", defaultValue: 1, labelName: "Cards draw per turn" },
                className: "box-secondary",
                labelSubtitle: "New turn options",
            },
            "defaultNotes": { type: "String", labelName: "Default notes", help: "Default player notes. Will be applied to all players when each game starts" },
            "tokens": {
                arrayContent: {
                    "name": { type: "String", defaultValue: "", labelName: "Name" },
                    "image": { type: "String", defaultValue: "", labelName: "Image URL" },
                    "isUnique": { type: "Bool", defaultValue: true, labelName: "Is unique", help: "If another player takes it, it will be removed from the player who currently have it" },
                    "leavesAtEndOfTurn": { type: "Bool", defaultValue: false, labelName: "Leaves at the end of turn", help: "Will be removed from players when the turn ends" }
                },
                className: "box-secondary",
                defaultValue: {
                    name: "",
                    image: "",
                    isUnique: true,
                    leavesAtEndOfTurn: false
                },
                labelSubtitle: "Tokens"
            },
            "countersStartingValues": {
                arrayContent: {
                    arrayKey: { type: "Number", defaultValue: 0 }
                },
                className: "box-secondary",
                defaultValue: 0,
                labelSubtitle: "Player counters starting value (min 1, max 2)",
                help: "ALWAYS HAVE AT LEAST 1 AND NEVER MORE THAN 2"
            },
            "hideFacedDownCards": { type: "Bool", labelName: "Prevent seeing your own faced down card ", help: "If set to yes, the player won't be able to see it's faced down cards at all time without flipping them" },
            "sections": {
                "customSections": {
                    arrayContent: {
                        arrayKey: { type: "String", defaultValue: "" }
                    },
                    className: "box-secondary",
                    defaultValue: "",
                    labelSubtitle: "Custom sections name list",
                    help: "All board sections in which the players will be able to drop cards (except hand, deck, discard, pile and removed). List their name here. Make sure to use the exact same name in the Layout and the Sections Data below. Forbidden section names are Hand, Deck, Stack, Discard and Exile"
                },
                "layout": { type: "Layout" },
                "categoriesAlreadyOnBoard": {
                    arrayContent: {
                        arrayKey: { type: "String", defaultValue: "" }
                    },
                    className: "box-secondary",
                    defaultValue: "",
                    labelSubtitle: "Deck categories that start the game on board",
                    help: "The deck category should match the section in which they are placed"
                },
                "autoPlayFromHand": {
                    isDictionary: true,
                    labelSubtitle: "Play cards from Hand",
                    className: "box-secondary",
                    help: "Where should a clicked card from hand go by default. The first value is the card type (should match the value used in your card file). The second value is the game section (should match the name used in this file)",
                    defaultValue: "",
                    dictionaryKey: { type: "String", defaultValue: "" },
                },
                "autoPlayFromStack": {
                    isDictionary: true,
                    labelSubtitle: "Play cards from Pile",
                    className: "box-secondary",
                    help: "Where should the top card of the Pile go when a player press the Play button. Same model as play cards from Hand",
                    defaultValue: "",
                    dictionaryKey: { type: "String", defaultValue: "" },
                },
                "sectionsDict": {
                    isDictionary: true,
                    labelSubtitle: "Sections data",
                    className: "box-primary",
                    hasMultipleKeys: true,
                    help: "This is where you will define the behavior or each area of the player board",
                    defaultValue: {
                        "title": "New_Section",
                        "isHidden": "no",
                        "height": "SMALL",
                        "alignment": "CENTER",
                        "opponentAlignment": false,
                        "noAutoPayTo": false,
                        "isHorizontalAllowed": true,
                        "displayedTitle": "",
                        "noQuickActions": false,
                        "enterTapped": false,
                        "enterSpun": false,
                        "isGroupForbidden": false,
                        "keepTappedNewTurn": false,
                        "showHiddenCardInHistory": false,
                    },
                    dictionaryKey: {
                        "title": { type: "String", defaultValue: "", labelName: "Title", help: "This is the identifier. It must match the value above. This is the area name you should use everywhere else on this file. Make sure there is no space (' ') in it, use '_' instead. If your game use a ressource mechanic like MTG or Lorcana, call the section 'Mana' for cards to be tapped automatically when paying cost" },
                        "isHidden": { type: "Select", defaultValue: "no", choices: [{ value: "no", title: "Face up to everyone" }, { value: "opponent-only", title: "Face down to your opponents only" }, { value: "yes", title: "Face down to everyone" }], labelName: "Are cards hidden", help: "Who can see the card when it's played in this area ? Ignored for cards that are already hidden to everyone" },
                        "height": { type: "Select", defaultValue: "MEDIUM", choices: [{ value: "SMALL", title: "Small" }, { value: "MEDIUM", title: "Medium" }, { value: "BIG", title: "Big" }], labelName: "Height", help: "Size of the cards played in this section" },
                        "alignment": { type: "Select", defaultValue: "CENTER", choices: [{ value: "START", title: "Start" }, { value: "CENTER", title: "Center" }, { value: "END", title: "End" }], labelName: "Alignment" },
                        "opponentAlignment": { type: "Select", defaultValue: false, choices: [{ value: "START", title: "Start" }, { value: "CENTER", title: "Center" }, { value: "END", title: "End" }, { value: false, title: "Same as player" }], labelName: "Different alignment for opponents", help: "For visual purpose, you might want the opponents card alignments in this section to be different from the main player's" },
                        "noAutoPayTo": { type: "Bool", defaultValue: false, labelName: "No autopay to place cards in this section", help: "Cards played here are always played for free" },
                        "isHorizontalAllowed": { type: "Bool", defaultValue: true, labelName: "Are horizontal cards allowed", help: "Should horizontal card be shown horizontally when played here ? Or Vertically like normal cards ? (like the hand for example)" },
                        "isGroupForbidden": { type: "Bool", defaultValue: false, labelName: "Are groupped cards forbidden" },
                        "displayedTitle": { type: "String", defaultValue: "", labelName: "Custom displayed title", help: "By default the area will have it's title displayed. You can define a different name here. Keep empty to ignore it and use the default title" },
                        "noQuickActions": { type: "Bool", defaultValue: false, labelName: "No quick actions", help: "Hide the quick action buttons that affect all cards in the area." },
                        "enterTapped": { type: "Bool", labelName: "Cards enter tapped", help: "Should card played here be tapped automatically" },
                        "enterSpun": { type: "Bool", labelName: "Cards enter rotated by 180 degrees", help: "Should card played here be rotated by 180 degrees automatically" },
                        "isGroupForbidden": { type: "Bool", labelName: "Are groupped cards forbidden", help: "If set to yes, a groupped card moved here will be degroupped" },
                        "keepTappedNewTurn": { type: "Bool", labelName: "Keep tapped on new turn", help: "All cards are untapped when the new turn start. Set this to yes if you want cards in this area to only be untapped automatically by the player" },
                        "showHiddenCardInHistory": { type: "Bool", labelName: "Hidden cards appears in history", help: "If set to yes, a faced down card played faced down here will have it's name appear in the history. Use this if the cards is played faced down but needs to be revealed to other players." },
                        className: "box-secondary"
                    }
                }
            }
        }
    },
    "defaultRessources": {
        labelTitle: "Default game ressources for players",
        className: "box-primary",
        "backgrounds": {
            labelSubtitle: "Playmats images",
            className: "box-secondary",
            help: "Playmats available to players in the preferences. Try to have at least one",
            defaultValue: "",
            arrayContent: {
                arrayKey: { type: "String", defaultValue: "" }
            }
        },
        "decksUrl": {
            labelName: "Preconstructed decks file URL",
            className: "box-secondary",
            help: "The URL to a JSON file containing an array of decks. Preconstructed decks in this file will be available to all players in game when choosing a deck. The file should look like this [DECK1, DECK2, ...] with the deck data in the TCG Arena starter deck format (you'll find it in the export menu in the deckbuilder)",
            type: "String",
        }
    },
    "customHelp": { type: "String", defaultValue: "", className: "box-secondary", labelName: "Custom help message", help: "Message displayed in the help section in game" },
    "cardRotation": { type: "Number", labelName: "Card rotation when tapped", help: "By how many degrees should a card be tapped when clicking it. 45 degrees is recommended. Choosing 90 degrees is not recommended if your game uses horizontal cards" },
    "cards": {
        className: "box-secondary",
        labelSubtitle: "Cards data",
        "dataUrl": { type: "String", defaultValue: "", labelName: "Card list .json URL", help: "URL to the card list file you created earlier" },
        "cardBack": { type: "String", defaultValue: "", labelName: "Card back image URL" }
    }
}
